<section class="landing">
  <header class="landing__intro">
    <p class="landing__eyebrow">Livestock Bordereau</p>
    <h1 class="landing__title">Select a division</h1>
    <p class="landing__subtitle">
      Choose which set of Bordereau reports to work with. Your role determines which
      divisions are available.
    </p>
  </header>

  <app-treasury-status></app-treasury-status>

  <div class="landing__grid">
    @for (division of divisions; track division.key) {
      <a class="division-card" [class.division-card--locked]="!treasury.isLoadedToday()"
         [routerLink]="division.route" [style.--accent]="division.color">
        <span class="division-card__count">{{ division.reportCount }} reports</span>
        <span class="division-card__icon"><i [class]="division.icon" aria-hidden="true"></i></span>
        <h2 class="division-card__name">{{ division.name }}</h2>
        <p class="division-card__desc">{{ division.description }}</p>
        @if (!treasury.isLoadedToday()) {
          <span class="division-card__warn">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> Load Treasury rates first
          </span>
        }
        <span class="division-card__go">
          Open {{ division.name }} reports
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </span>
      </a>
    }
  </div>

  <div class="landing__manage">
    <p class="landing__manage-label">Approval Hub</p>
    <a class="manage-card" routerLink="/approvals" [style.--accent]="'#195C7D'">
      <span class="manage-card__icon"><i class="pi pi-check-square" aria-hidden="true"></i></span>
      <span class="manage-card__body">
        <span class="manage-card__name">Approval Dashboard</span>
        <span class="manage-card__desc">
          Track each reporting period through review, approval and sign-off across Actuary and Finance.
        </span>
      </span>
      <span class="manage-card__go"><i class="pi pi-arrow-right" aria-hidden="true"></i></span>
    </a>
  </div>

  <div class="landing__manage">
    <p class="landing__manage-label">Data maintenance</p>
    <a class="manage-card" routerLink="/static-values" [style.--accent]="'#6A5ACD'">
      <span class="manage-card__icon"><i class="pi pi-sliders-h" aria-hidden="true"></i></span>
      <span class="manage-card__body">
        <span class="manage-card__name">Static - Input Values</span>
        <span class="manage-card__desc">
          View and edit the static - input values by reinsurance year. Changes are audit-logged.
        </span>
      </span>
      <span class="manage-card__go"><i class="pi pi-arrow-right" aria-hidden="true"></i></span>
    </a>
  </div>
</section>
